(function(){
  'use strict';
  angular.module('app').config(affiliateSale);
  affiliateSale.$inject = ['$routeProvider', '$locationProvider'];

  function affiliateSale($routeProvider, $locationProvider){
      $routeProvider.
      when('/affiliates-sales/approval-report',{
        templateUrl: '/templates/pages/affiliateSales/reportApproval.html',
        controller: 'ReportApprovalController',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Report Approvals',
          icon:'fa fa-book',
          pageTitle: 'Report Approvals'
        }
      }).
      when('/affiliates-sales/create',{
        templateUrl: '/templates/pages/affiliateSales/createProfile.html',
        controller: 'CreateProfileController',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Create New Profile',
          icon:'fa fa-user', 
          pageTitle: 'Create New Profile'
        }
      }).
      when('/affiliates-sales/:id',{
        templateUrl: '/templates/pages/affiliateSales/createProfile.html',
        controller: 'EditProfileController',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Create New Profile',
          icon:'fa fa-user', 

          pageTitle: 'View Profile'
        }
      }).
      when('/affiliates-sales/summary/:id',{
        templateUrl: '/templates/pages/affiliateSales/detailedSummary.html',
        controller: 'SummaryDetailsController',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Financial Summary',
          icon:'fa fa-user', 
          pageTitle: 'Financial Summary'
        }
      }).
      when('/affiliates-sales/accounts/:id',{
        templateUrl: '/templates/pages/affiliateSales/accounts/accounts.html',
        controller: 'ViewAllAccountsController',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Financial Summary',
          icon:'fa fa-user', 
          pageTitle: 'Accounts '
        }
      }).
      when('/affiliates-sales/accounts/:id/new',{
        templateUrl: '/templates/pages/affiliateSales/createProfile.html',
        controller: 'AffiliateAccountsController',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Financial Summary',
          icon:'fa fa-user', 
          pageTitle: 'Accounts '
        }
      }).
      when('/affiliates-sales/accounts/edit/:id',{
        templateUrl: '/templates/pages/affiliateSales/createProfile.html',
        controller: 'AffiliateEditAccountsController',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Financial Summary',
          icon:'fa fa-user', 
          pageTitle: 'Accounts '
        }
      }).
      when('/affiliates-sales/financial/:id',{
        templateUrl: '/templates/pages/affiliateSales/createProfile.html',
        controller: '',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Financial Summary',
          icon:'fa fa-user', 
          pageTitle: 'Accounts '
        }
      }).
      when('/affiliates-sales/referred/:id',{
        templateUrl: '/templates/pages/affiliateSales/createProfile.html',
        controller: 'RefferedDetailsController',
        controllerAs: 'vm',
        params: {
          parent: 'affiliates-sales',
          htmlTitle: 'Financial Summary',
          icon:'fa fa-user', 
          pageTitle: 'Accounts '
        }
      })
  }
})();


// WEBPACK FOOTER //
// ./js/urls/affiliateSale.js